import baseApi from 'shared/api/baseApi';

import type { AlertType } from '../types/alertsConfig';

type PostTestAlertsResponse = { message: string };
type PostTestAlertsBody = { text: string; alertsConfig: AlertType[] };

const alertsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getStandardAlerts: build.query<AlertType[], void>({
      query: () => ({ url: '/alerts/standard', method: 'GET' }),
      transformResponse: (response: { standardAlerts: AlertType[] }) => response.standardAlerts,
    }),
    postTestAlerts: build.mutation<PostTestAlertsResponse, PostTestAlertsBody>({
      query: (body) => ({
        url: '/alerts/test',
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetStandardAlertsQuery, usePostTestAlertsMutation } = alertsApi;
